import React from 'react';

import * as color from '../../../constants/colors';


class RhinoLoading extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className='RhinoLoading'>
				<div className='loadingImgWrapper'>
					<img src='/img/loading.gif' alt='DD Loading' width='200' height='200' />
				</div>
				<div className='loadingImgPhoneWrapper'>
					<img src='/img/loading.gif' alt='DD Loading' width='100' height='100' />
				</div>
				<div className='loadingMessage'>{this.props.message}</div>
			</div>
		);
	}
}
export default RhinoLoading;